export default {
    namespaced: true,

    state: {
        activeLocations: [],
        locations: [],
        locationIds: [],
        locationHeader: "",
        locationsEnabled: false
    },
    mutations: {
        setActiveLocations(state, location) {
            if (!state.activeLocations.includes(location)) {
                state.activeLocations.push(location);

            } else if (state.activeLocations.includes(location)) {
                state.activeLocations = state.activeLocations.filter(
                    el => el !== location
                );
            }
        },
        setLocationData(state, rootState) {
            state.locations = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty("Locations");
                })
                .map(filtered => {
                    return filtered.Locations;
                })[0];

            state.defaultLocation = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty("DefaultLocation");
                })
                .map(filtered => {
                    return filtered.DefaultLocation;
                })[0];

            if (state.locations && state.locations.length > 0) {
                state.locations.forEach(location => {
                    if (location.Key === state.defaultLocation) {
                        location.checked = true;
                    } else {
                        location.checked = false;
                    }
                });
            }

            if (state.defaultLocation) {
                if (!state.activeLocations.includes(state.defaultLocation)) {
                    state.activeLocations.push(state.defaultLocation);
                }

                if (!state.locationIds.includes(state.defaultLocation)) {
                    state.locationIds.push(state.defaultLocation);
                }
            }

            if (state.locations && state.locations.length > 0) {
                state.locationsEnabled = true;
            }

            state.locationHeader = rootState.attractions
                .filter(attraction => {
                    return attraction.hasOwnProperty("LocationHeader");
                })
                .map(filtered => {
                    return filtered.LocationHeader;
                })[0];
        },
        setLocationsIds(state, payload) {
            if (!state.locationIds.includes(payload)) {
                state.locationIds.push(payload);
            } else if (state.locationIds.includes(payload)) {
                state.locationIds = state.locationIds.filter(
                    el => el !== payload
                );
            }
        },
        setLocationValuesFromCookie(state, payload) {
            if (payload.locations) {
                state.activeLocations = payload.locations;
            }
        },
        toggleCheckedLocation(state, key) {
            state.locations.forEach(location => {
                if (location.Key === key) {
                    location.checked = !location.checked;
                }
            });
        }
    },
    actions: {
        toggleActiveLocations({ commit }, location) {
            commit("setLocationsIds", location);
            commit("setActiveLocations", location);
        }

    }
}